<script setup lang="ts">
// Admin / operations console shell — dense, data-first (doc 04 §9.1).
import AppTopBar from '@/components/layout/AppTopBar.vue'
import AdminSidebar from '@/components/layout/AdminSidebar.vue'
</script>

<template>
  <AppTopBar />
  <AdminSidebar />
  <v-main>
    <v-container fluid class="pa-6">
      <slot />
    </v-container>
  </v-main>
</template>
